<template>
<div>
    <div class="className" id="multipleBarsLines2" style="height:300px; width:'100%'" ></div>
</div>
</template>

<script>
import echarts from "echarts";
export default {
    props: ["pointLists"],
      watch: {
        pointLists: function(newVal, oldVal) {
            newVal.forEach(element => {
                this.actual.push(element.name)
                this.target.push(element.goalMark)
                this.courseNames.push(element.classAvgMark)
            });
            this.initChart2();
        }
      },
    data() {
        return {
            chart: null,
              actual: [],  //名称
              target: [],   //  我的达成度
              courseNames: []  // 平均达成度
        };
    },
    created() {
        this.$nextTick(() => {
            this.initChart2();
        });

    },
    methods: {
        initChart2() {
            this.chart = echarts.init(document.getElementById("multipleBarsLines2"));
            var option = {
                backgroundColor: '#FFFFFF',
                title: {
                    //text: '检查企业信息分析'
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: { // 坐标轴指示器，坐标轴触发有效
                        type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
                    }
                },
                legend: {
                    // data: ['我的达成度', '班级平均达成度'],
                    data:[{name:'我的达成度',icon: 'circle',},{name:'班级平均达成度',icon: 'circle',}],
                    textStyle: {
                        // fontSize: 12,
                        color: '#969696'
                    },
                },

                grid: {
                    left: '4%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                xAxis: [{
                    // type: 'category',
                    // data: ['课程目标1', '课程目标2', '课程目标3', '课程目标4'],
                    data:this.actual,
                    // 坐标轴刻度标签的相关设置  
                    axisLabel: {  
                        interval:0,  
                       rotate:this.actual.length > 5 ? 45 : 0 
                    },
                    axisLine: {
                        show: false,
                        lineStyle: {
                            color: "#323232",
                            show: false
                        }
                    },
                    axisTick: {
                        show: false,
                        color: '#323232'
                    },
                }],
                dataZoom: [
                    {
                        type: "slider",
                        show: true,
                        xAxisIndex: [0],
                        left: "7%",
                        bottom: -25,
                        start: 0,
                        end: 90 //初始化滚动条
                    }
                ],
                yAxis: [{
                    type: 'value',
                    //name: '投诉举报数',
                    // axisLabel: {
                    //     formatter: '{value}'
                    // },
                    axisLine: {
                        show: false,
                        lineStyle: {
                            color: "#969696"
                        }
                    },
                    splitLine: {
                        show: true,
                        lineStyle: {
                            color: '#F4F4F4'
                        }
                    },
                    axisTick: {
                        show: false,
                        color: '#323232'
                    },
                }],
                series: [{
                    name: '我的达成度',
                    type: 'bar',
                    barGap:'0%',
                    barCategoryGap: "10%",
                    itemStyle: {
                        normal: {
                            color: '#37A0FF'
                        },
                    },
                    markPoint: {

                    },
                    barWidth:20,
                    // data: [0.1, 0.25, 0.12, 0.16]
                    data:this.target
                }, {
                    name: '班级平均达成度',
                    type: 'bar',
                    itemStyle: {
                        normal: {
                            color: 'rgba(54,213,148,.4)'
                        },
                    },
                    // data: [0.16, 0.19, 1, 0.43]
                     barWidth:20,
                    data:this.courseNames
                }]
            };
            this.chart.setOption(option);
        }
    }
};
</script>

<style lang="scss">
.className {
    width: 100%;
    height: 300px;
    margin-bottom: 200px;
}
</style>
